import { useState } from "react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { X } from "lucide-react";
import { VisuallyHidden } from "@radix-ui/react-visually-hidden";

const GallerySection = ({ gallery }) => {
  const [selectedImage, setSelectedImage] = useState(null);

  return (
    <section id="galleria" className="py-24 bg-white" data-testid="gallery-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-[#5abb3d] font-semibold tracking-[0.2em] uppercase text-sm">
            Portfolio
          </span>
          <h2 className="font-outfit text-3xl sm:text-4xl font-bold text-[#29383d] mt-4 tracking-tight">
            I Nostri Lavori
          </h2>
          <p className="text-[#394b52] mt-4 max-w-2xl mx-auto leading-relaxed">
            Scopri alcuni dei progetti realizzati per i nostri clienti in tutto il Veneto
          </p>
        </div>

        {/* Gallery Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {gallery.map((item, index) => (
            <div
              key={item.id}
              className={`gallery-item group relative rounded-2xl overflow-hidden cursor-pointer opacity-0 animate-fade-in-up stagger-${(index % 6) + 1}`}
              onClick={() => setSelectedImage(item)}
              data-testid={`gallery-item-${item.id}`}
            >
              <div className="aspect-[4/3]">
                <img
                  src={item.image_url}
                  alt={item.title}
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
              
              {/* Overlay */}
              <div className="absolute inset-0 bg-[#29383d]/0 group-hover:bg-[#29383d]/70 transition-all duration-300 flex items-end">
                <div className="p-6 translate-y-full group-hover:translate-y-0 transition-transform duration-300">
                  <span className="inline-block px-3 py-1 bg-[#5abb3d] text-white text-xs font-semibold rounded-full mb-2 uppercase">
                    {item.category}
                  </span>
                  <h3 className="font-outfit text-lg font-bold text-white">
                    {item.title}
                  </h3>
                  <p className="text-white/80 text-sm mt-1">
                    {item.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Lightbox Dialog */}
        <Dialog open={!!selectedImage} onOpenChange={() => setSelectedImage(null)}>
          <DialogContent className="max-w-4xl p-0 overflow-hidden bg-[#29383d] border-none">
            <VisuallyHidden>
              <DialogTitle>{selectedImage?.title || "Immagine galleria"}</DialogTitle>
            </VisuallyHidden>
            <button
              onClick={() => setSelectedImage(null)}
              className="absolute top-4 right-4 z-10 w-10 h-10 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center text-white transition-colors"
              data-testid="lightbox-close-btn"
            >
              <X className="w-5 h-5" />
            </button>
            {selectedImage && (
              <div>
                <img
                  src={selectedImage.image_url}
                  alt={selectedImage.title}
                  className="w-full max-h-[70vh] object-contain"
                />
                <div className="p-6">
                  <span className="inline-block px-3 py-1 bg-[#5abb3d] text-white text-xs font-semibold rounded-full mb-2 uppercase">
                    {selectedImage.category}
                  </span>
                  <h3 className="font-outfit text-xl font-bold text-white">
                    {selectedImage.title}
                  </h3>
                  <p className="text-white/80 mt-2">
                    {selectedImage.description}
                  </p>
                </div>
              </div>
            )}
          </DialogContent>
        </Dialog>
      </div>
    </section>
  );
};

export default GallerySection;
